<template>
  <div>
    <div>
      <p>房型: {{ roomInfo.roomType }}</p>
    </div>
    <div>
      <p>时间: {{ roomInfo.date }}</p>
    </div>
    <div>
      <p>
        房价:
        <a-input-number
          :min="0"
          :max="1000000"
          v-model="roomPrice"
          :disabled="disable"
          style="width:50%;"
        />
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "editRoomPrice",
  props: {
    roomInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    disable: { type: Boolean, default: false }
  },
  data() {
    return {
      roomPrice: ""
    };
  },
  created() {
    this.roomPrice = this.roomInfo.roomPrice;
  },
  methods: {
    getEditRoomPrice() {
      if (!this.roomPrice) {
        this.$message.info("请正确填写房价！");
        return false;
      } else {
        return this.roomPrice;
      }
    }
  }
};
</script>
<style lang="less" scoped>
p {
  margin-left: 50px;
  margin-bottom: 10px;
}
</style>
